export const getThemeForAuto = (environment: string) => {
    if (environment === "vscode" || environment.includes("jetbrains")) {
        return "dark";
    }
    else if (environment.includes("web") || environment.includes("mobile")) {
        const currentHour = new Date().getHours();
        return currentHour >= 6 && currentHour < 19 ? "light" : "dark";
    }
    else if (environment === "chrome") {
        return null;
    }
};
